<template>
<div>
    <div class="row d-flex align-items-center justify-content-center">
        <div class="col-10">
            <Button @click="$router.go(-1)" size="small" type="outline" color="grey">
                <ArrowDropdown :rotate="90" /> Voltar
            </Button>
        </div>
        <div class="col-10 my-4">
            <h3 class="c-ndarkthree">
                <span class="bold">{{ this.$route.path.includes('edit') ? groupName : 'Novo grupo econômico' }}</span> | Regras da operação
            </h3>
        </div>
        <div class="col-10">
            <el-steps direction="vertical" :active="activeStep" finish-status="success">
                <el-step title="Selecionar produtos de crédito" v-if="!USER_TYPE_MIXIN.isBackOffice">
                    <div class="col-8 mt-5 pl-0" slot="description" v-if="activeStep == 0">
                        <div class="d-flex mt-4 mb-4">
                            <el-checkbox v-model="groupRules.availableToMarketplace" :class="getPrimaryColor" @change="handleMarketplaceSelection" :disabled="groupRules.availableToInvoiceDeadlineExtension">
                                <span class="medium">
                                    Antecipação de recebíveis
                                </span>
                            </el-checkbox>

                            <el-checkbox v-model="groupRules.availableToInvoiceDeadlineExtension" :class="getPrimaryColor" @change="handleDeadlineExtensionSelection" :disabled="groupRules.availableToMarketplace">
                                <span class="medium">
                                    Alongamento de prazo
                                </span>
                            </el-checkbox>
                        </div>
                        <div class="mb-4" v-if="activeStep == 0 || !groupRules.availableToMarketplace">
                            <router-link to="" @click.native="$router.go(-1)">Voltar</router-link>
                            <Button :color="getPrimaryColor" :disabled="!groupRules.availableToMarketplace && !groupRules.availableToInvoiceDeadlineExtension" class="ml-3" @click="activeStep++">Continuar</Button>
                        </div>
                    </div>
                </el-step>
                <el-step :title="`Definir regras de ${groupRules.availableToMarketplace ?  'antecipação de recebíveis' : 'alongamento de prazo'}`" :status="!USER_TYPE_MIXIN.isBackOffice ? 'process' : 'wait'" v-if="groupRules.availableToInvoiceDeadlineExtension || groupRules.availableToMarketplace">
                    <div class="col-10 mt-4 pl-0" slot="description" v-if="activeStep == 1">
                        <div v-if="groupRules.availableToMarketplace == true">
                            <p class="c-ndarkfour bold mb-3">Qual o modelo de financiamento?</p>
                            <el-radio-group v-model="groupRules.orderAntecipationMode">
                                <el-radio :class="getPrimaryColor" label="marketplace">Todos financiadores exclusivos</el-radio>
                                <el-radio :class="getPrimaryColor" label="selected">Selecionar financiadores exclusivos</el-radio>
                            </el-radio-group>
                        </div>
                        
                        <div class="row mt-2 px-0">
                            <div class="col-12 mt-3" v-if="groupRules.orderAntecipationMode =='selected'">
                                <SponsorGroup :tableData="sponsorGroupData" @change="handleSelectionChange" :singleSelection="groupRules.availableToInvoiceDeadlineExtension"/>
                            </div>
                            <div class="col-12 mt-3 pt-3" v-if="groupRules.availableToMarketplace">
                                <p class="c-ndarkfour bold mb-3">Como os dados serão enviadas para a plataforma?</p>
                                <el-select :popper-class="getPrimaryColor" v-model="groupRules.dataImportType" :class="getPrimaryColor" style="width:362px">
                                    <el-option
                                        v-for="item in dataImportTypes"
                                        :key="item.type"
                                        :label="item.name"
                                        :value="item.type">
                                    </el-option>
                                </el-select>
                            </div>

                            <div class="col-12 mt-3 pt-3" v-if="groupRules.availableToMarketplace && ['worksheetOrProviderRequestsValue', 'providerRequestsValue', 'worksheet'].includes(groupRules.dataImportType)">
                                <p class="c-ndarkfour bold mb-3">Como os arquivos XMLs serão vinculados?</p>
                                <el-radio-group v-model="groupRules.XmlBindingType">
                                    <el-radio :class="getPrimaryColor" label="provider" value="provider">O fornecedor irá anexar</el-radio>
                                    <el-radio :class="getPrimaryColor" label="arquivei" value="arquivei">Via parceiro de integração</el-radio>
                                </el-radio-group>
                            </div>

                            <!-- <div class="col-12 mt-3 pt-3" v-if="groupRules.availableToMarketplace">
                                <p class="c-ndarkfour bold mb-3">Qual será o modelo de proposta?</p>
                                <el-radio-group v-model="groupRules.modelOffers">
                                    <el-radio :class="getPrimaryColor" label="manual">Manual</el-radio>
                                    <el-radio :class="getPrimaryColor" label="automatic">Automática</el-radio>
                                    <el-radio :class="getPrimaryColor" label="both">Financiador define</el-radio>
                                </el-radio-group>
                            </div> -->

                            <div class="col-12 mt-3 pt-3" v-if="(groupRules.availableToMarketplace) && (groupRules.XmlBindingType == 'arquivei')">
                                <div style="width:628px">
                                    <label for="">X-API-ID</label>
                                    <el-input :class="getPrimaryColor" v-model="groupRules.xApiId" placeholder="X-API-ID" style="width:628px"/>
                                </div>
                                <div class="mt-3">
                                    <label for="">X-API-KEY</label>
                                    <el-input :class="getPrimaryColor" v-model="groupRules.xApiKey" placeholder="X-API-KEY" style="width:628px"/>
                                </div>
                            </div>
                            <div class="col-12 mt-3 pt-3" v-if="groupRules.availableToMarketplace && groupRules.dataImportType !== 'buyerValidation'">
                                <p class="c-ndarkfour bold mb-3">O fornecedor precisa anexar o arquivo XML?</p>
                                <el-radio-group v-model="groupRules.xmlRequiredForAnticipation">
                                    <el-radio :class="getPrimaryColor" :label="true">Sim</el-radio>
                                    <el-radio :class="getPrimaryColor" :label="false">Não</el-radio>
                                </el-radio-group>
                            </div>
                            <div class="col-12 mt-3 pt-3" v-if="groupRules.xmlRequiredForAnticipation && groupRules.availableToMarketplace && groupRules.dataImportType !== 'buyerValidation'">
                                <p class="c-ndarkfour bold mb-3">Quais os tipos de nota é obrigatório o cedente anexar?</p>
                                <el-checkbox-group v-model="groupRules.orderTypeRequiresXmlOrPdf" class="d-flex">
                                    <el-checkbox :class="getPrimaryColor" key="1" label="1" value="1" class="mr-4">
                                        NFe
                                    </el-checkbox>
                                    <el-checkbox :class="getPrimaryColor" key="2" label="2" value="2" class="mr-4">
                                        NFSe
                                    </el-checkbox>
                                    <el-checkbox :class="getPrimaryColor" key="4" label="4" value="4">
                                        CTe
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>

                            <div class="col-12 mt-3 pt-3" v-if="USER_TYPE_MIXIN.isAdm && groupRules.availableToMarketplace && groupRules.dataImportType !== 'buyerValidation'">
                                <p class="bold mb-3 c-ndarkfour">Enviar automaticamente as notas para antecipação?</p>
                                <el-radio-group v-model="groupRules.autoSendToMkt" >
                                    <el-radio :class="getPrimaryColor" :label="true">Sim</el-radio>
                                    <el-radio :class="getPrimaryColor" :label="false">Não</el-radio>
                                </el-radio-group>
                            </div>

                            <div class="col-12 mt-3 pt-3" v-if="!USER_TYPE_MIXIN.isBackOffice && groupRules.availableToMarketplace">
                                <p class="c-ndarkfour bold mb-3">Quais formas de pagamento permitem antecipação?</p>
                                <el-radio-group v-model="groupRules.allowedPaymentType">
                                    <el-radio :class="getPrimaryColor" label="all">Todos</el-radio>
                                    <el-radio :class="getPrimaryColor" label="billets">Apenas boleto</el-radio>
                                    <el-radio :class="getPrimaryColor" label="accountCredit">Apenas crédito em conta</el-radio>
                                </el-radio-group>
                            </div>

                            <div class="col-12 mt-3 pt-3" v-if="groupRules.availableToMarketplace" style="width:326px">
                                <p class="c-ndarkfour bold mb-3">O cedente pode antecipar as duplicatas em até quantos dias antes do vencimento?</p>
                                <el-input :class="getPrimaryColor" v-model="groupRules.daysAllowedSendOrderToMarket" placeholder="5 dias" v-money="daysNumber" style="width:326px"/>
                            </div>

                            <div class="col-12 mt-3 pt-3" v-if="!USER_TYPE_MIXIN.isBackOffice">
                                <p class="c-ndarkfour bold mb-3">Exibir o status de vencimento?</p>
                                <el-radio-group v-model="groupRules.confirmStatus">
                                    <el-radio :class="getPrimaryColor" :label="true">Sim</el-radio>
                                    <el-radio :class="getPrimaryColor" :label="false">Não</el-radio>
                                </el-radio-group>
                            </div>

                            <div class="col-12 mt-3 pt-3" v-if="groupRules.availableToMarketplace">
                                <p class="c-ndarkfour bold mb-3">
                                    Em qual status a nota pode ir para <span>{{ getWhiteLabel !== 'CASHFORCE' ? 'negociação' : 'o marketplace'}}</span>?
                                </p>
                                <el-radio-group v-model="groupRules.orderStatusAllowedToMarketplace">
                                    <el-radio :class="getPrimaryColor" :label="3">Nota fiscal vinculada</el-radio>
                                    <el-radio :class="getPrimaryColor" :label="5">Pagamento autorizado</el-radio>
                                </el-radio-group>
                            </div>


                            <div class="col-12 mt-3 pt-3" v-if="getWhiteLabel === 'CASHFORCE'">
                                <p class="c-ndarkfour bold mb-3">Confirma a mercadoria?</p>
                                <el-radio-group v-model="groupRules.confirmMerchandise">
                                    <el-radio :class="getPrimaryColor" :label="true">Sim</el-radio>
                                    <el-radio :class="getPrimaryColor" :label="false">Não</el-radio>
                                </el-radio-group>
                            </div>

                            <div class="col-12 mt-3 pt-3" v-if="(!USER_TYPE_MIXIN.isBackOffice || getWhiteLabel === 'NETMONEY')">
                                <p class="c-ndarkfour bold mb-3">Qual o cashback das operações?</p>
                                <label>Cashback (%)</label>
                                <Money class="input-money col-4" v-model="groupRules.cashbackOperation" v-bind="percentageNumber" />
                            </div>
                            <div class="col-12 mt-3 pt-3" v-if="!USER_TYPE_MIXIN.isBackOffice">
                                <p class="c-ndarkfour bold mb-3">Quem paga o cashback?</p>
                                <el-radio-group v-model="groupRules.whoPaysCashback">
                                    <el-radio :class="getPrimaryColor" label="sponsor">Financiador</el-radio>
                                    <el-radio :class="getPrimaryColor" label="cashforce">Cashforce</el-radio>
                                </el-radio-group>
                            </div>

                            <div class="col-12 mt-3 pt-3" v-if="!USER_TYPE_MIXIN.isBackOffice && groupRules.availableToMarketplace" >
                                <p class="c-ndarkfour bold mb-3">Permite o agrupamento das duplicatas em lotes?</p>
                                <el-radio-group v-model="groupRules.allowLots">
                                    <el-radio :class="getPrimaryColor" :label="true">Sim</el-radio>
                                    <el-radio :class="getPrimaryColor" :label="false">Não</el-radio>
                                </el-radio-group>
                            </div>

                            <div class="col-12 mt-3 pt-3" v-if="groupRules.availableToMarketplace">
                                <p class="c-ndarkfour bold mb-3">Mostrar as taxas e tarifas para o cedente?</p>
                                <el-radio-group v-model="groupRules.canProviderSeeFees">
                                    <el-radio :class="getPrimaryColor" :label="true">Sim</el-radio>
                                    <el-radio :class="getPrimaryColor" :label="false">Não</el-radio>
                                </el-radio-group>
                            </div>

                            <div class="col-12 mt-3 pt-3">
                                <p class="c-ndarkfour bold mb-3">Mostrar o contas a receber para o cedente?</p>
                                <el-radio-group v-model="groupRules.showReceivableTab">
                                    <el-radio :class="getPrimaryColor" :label="true">Sim</el-radio>
                                    <el-radio :class="getPrimaryColor" :label="false">Não</el-radio>
                                </el-radio-group>
                            </div>

                            <div class="col-12 mt-3 pt-3" v-if=" groupRules.availableToInvoiceDeadlineExtension">
                                <p class="c-ndarkfour bold mb-3">Qual é a taxa de juros?</p>
                                <Money class="input-money col-5" v-model="groupRules.interestRatePerMonth" v-bind="percentageNumber" />
                                
                            </div>
                            
                            <div class="col-12 mt-3 pt-3" v-if="groupRules.availableToInvoiceDeadlineExtension">
                                <p class="c-ndarkfour bold mb-3">Qual é o prazo adicional?</p>
                                <el-input :class="getPrimaryColor" v-model="groupRules.extendedDeadlineDays" placeholder="60 dias" v-money="daysNumber" style="width:326px"/>
                            </div>
                            
                            <div class="col-12 mt-5 mb-4">
                                <router-link :class="`${getPrimaryColor} c-ndarkfour`" to="" @click.native="activeStep--">Voltar</router-link>
                                <Button :color="getPrimaryColor" class="ml-3" :disabled="groupRules.orderAntecipationMode =='selected' && !selection.length" @click="insertGroupRules">Finalizar</Button>
                            </div>

                        </div>
                    </div>
                    <div class="col-8">
                    </div>
                </el-step>
            </el-steps>
        </div>
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-if="$store.state.user.loading"/>
    <ChangesDelayTime :dialogVisible="dialogVisible" @closeModal="handleRedirect" />
</div>
</template>

<script>

// Libraries
import { Money } from 'v-money'

// Components
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import SponsorGroup from '@/components/tables/SponsorGroup'
import FullLoading from '@/components/loading/FullLoading'
import ChangesDelayTime from '@/components/modals/ChangesDelayTime'

// APIs
import getSponsorsEconomicGroup from '@/api/getSponsorsEconomicGroup'
import getEconomicGroupSponsors from '@/api/getEconomicGroupSponsors'
import getEconomicGroupRules from '@/api/getEconomicGroupRules'
import updateEconomicGroupRules from '@/api/updateEconomicGroupRules'
import updateEconomicGroupSponsors from '@/api/updateEconomicGroupSponsors'
import addAllSponsorsToGroup from '@/api/addAllSponsorsToGroup'
import addProvidersToSponsorByGroup from '@/api/addProvidersToSponsorByGroup'
import deleteProvidersFromSponsorByGroup from '@/api/deleteProvidersFromSponsorByGroup'


export default {
    components: {
        ArrowDropdown,
        SponsorGroup,
        ChangesDelayTime,
        Money,
        FullLoading
    },
    data() {
        return {
            percentageNumber: {
                decimal: ',',
                thousands: '.',
                precision: 2,
                suffix: '%',
                masked: false
            },
            daysNumber: {
                suffix: 'dias',
                masked: false,
            },
            groupRules: {
                availableToMarketplace: false,
                availableToFomentation: false,
                orderAntecipationMode: 'marketplace',
                confirmMerchandise: true,
                cashbackOperation: '',
                providerAllowedSendOrderToMarket: false,
                orderStatusAllowedToMarketplace: 5,
                buyerSendXml: false,
                daysAllowedSendOrderToMarket: '',
                providerProvideBillets: true,
                allowLots: false,
                whoPaysCashback: 'cashforce',
                confirmStatus: false,
                allowedPaymentType: "all",
                autoSendToMkt: false,
                xmlRequiredForAnticipation: true,
                interestRatePerMonth: 0,
                extendedDeadlineDays: 60,
                dataImportType: 'integration',
                canProviderSeeFees: true,
                showReceivableTab: false,
                modelOffers: 'manual',
                xApiKey: '',
                xApiId: '',
                XmlBindingType: 'provider',
                orderTypeRequiresXmlOrPdf: [],
            },
            activeStep: 0,
            selection: [],
            sponsorGroupData: [],
            sponsorIdsToDelete: [],
            dialogVisible: false,
            dataImportTypes: [
                {
                    name: 'Integração com o sacado',
                    type: 'integration'
                },
                {
                    name: 'Integração ou validação manual pelo sacado',
                    type: 'integrationOrBuyerValidation'
                },
                {
                    name: 'Integração ou importação de planilha',
                    type: 'integrationOrWorksheet'
                },
                {
                    name: 'Importação de planilha',
                    type: 'worksheet'
                },
                {
                    name: 'Validação manual do sacado',
                    type: 'buyerValidation'
                },
                {
                    name: 'Validação manual do sacado ou importação de planilha',
                    type: 'buyerValidationOrWorksheet'
                },
                {
                    name: 'Cliente solicita o valor',
                    type: 'providerRequestsValue'
                },
                {
                    name: 'Cedente solicita ou o sacado importa a planilha',
                    type: 'worksheetOrProviderRequestsValue'
                },
            ]
        }
    },
    computed: {
        groupName() {
            return this.$store.state.group.groups.find(group => group.id == this.$route.params.groupId).name
        }
    },
    watch: {
        'groupRules.buyerSendXml': function (withXml) {
            if (withXml == false) {
                this.groupRules.providerAllowedSendOrderToMarket = true
            }
        },
        'groupRules.xmlRequiredForAnticipation': function (data) {
            if (data == false) {
                this.groupRules.orderTypeRequiresXmlOrPdf = []
            }
            if (data == true) {
                this.groupRules.orderTypeRequiresXmlOrPdf = ['1', '2', '4']
            }
        },

        // 'groupRules.orderTypeRequiresXmlOrPdf': {
        //     handler(newValue) {
        //         if (newValue.includes('all')) {
        //             // Se "todos" foi selecionado, seleciona todos os outros
        //             this.groupRules.orderTypeRequiresXmlOrPdf = ['all', 1, 2, 4];
        //         } else if (newValue.length === 3) {
        //             // Se todos os outros foram selecionados, seleciona "todos"
        //             this.groupRules.orderTypeRequiresXmlOrPdf = ['all', 1, 2, 4];
        //         } else {
        //             // Remove "todos" se algum item foi desmarcado
        //             this.groupRules.orderTypeRequiresXmlOrPdf = newValue.filter(item => item !== 'all');
        //         }
        //     },
        //     deep: true
        // }
    },
    methods: {
        async insertGroupRules() {
            const { orderAntecipationMode } = this.groupRules

            if (orderAntecipationMode == 'marketplace'){
                await addAllSponsorsToGroup(this.$route.params.groupId)
                await addProvidersToSponsorByGroup(this.$route.params.groupId)
            }

            if (orderAntecipationMode == 'selected') {
                const sponsorIdsToDelete = this.sponsorGroupData
                    .filter(sponsor => !this.selection.includes(sponsor.id))
                    .map(sponsor => sponsor.id)

                await updateEconomicGroupSponsors(this.$route.params.groupId, {
                    sponsorIds: this.selection,
                    sponsorIdsToRemove: sponsorIdsToDelete,
                })

                await deleteProvidersFromSponsorByGroup(this.$route.params.groupId, {
                    sponsorIds: sponsorIdsToDelete
                })
                
                await addProvidersToSponsorByGroup(this.$route.params.groupId, {
                    sponsorIds: this.selection
                })


            }

            const result = await updateEconomicGroupRules(this.$route.params.groupId, {
                ...this.groupRules,
                cashbackOperation: this.groupRules.cashbackOperation / 100
            })

            if (result.data.ok) {
                const notifyTitle = this.$route.path.includes('edit') ? 'Alterações salvas com sucesso!' : 'Grupo econômico criado com sucesso!'
                this.$notify({
                    title: notifyTitle,
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
                this.handleRedirect()
            } else {
                this.$notify({
                    title: 'Opa! Encontramos algum erro.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
            }
        },
        handleRedirect() {
            this.$router.push('/group')
        },
        handleSelectionChange($event) {
            this.selection = $event
            this.sponsorGroupData = this.sponsorGroupData.sort((a, b) => {
                if (this.selection.includes(a.id)) {
                    return -1; // "a" vem antes de "b"
                } else if (this.selection.includes(b.id)) {
                    return 1; // "b" vem antes de "a"
                } else {
                    return 0; // Mantenha a ordem original
                }
            })
        },
        updateRulesByDeadlineExtensionSelection() {
            this.groupRules.orderAntecipationMode = 'selected'
            this.groupRules.autoSendToMkt = false
            this.groupRules.orderStatusAllowedToMarketplace = 5
            this.groupRules.xmlRequiredForAnticipation = false
        },
        handleDeadlineExtensionSelection(updatedValue) {
            if (updatedValue == 1) {
                this.groupRules.availableToMarketplace = false
                this.updateRulesByDeadlineExtensionSelection()
            }
        },
        handleMarketplaceSelection(updatedValue) {
            if (updatedValue == 1) {
                this.groupRules.availableToInvoiceDeadlineExtension = false

            }
        }
    },
    async created() {
        const result = await getSponsorsEconomicGroup()
        if (result.data.ok) this.sponsorGroupData = result.data.payload
        if (this.$route.path.includes('edit')) {
            const resultAssociatedSponsors = await getEconomicGroupSponsors(this.$route.params.groupId)
            const resultRules = await getEconomicGroupRules(this.$route.params.groupId)
            if (resultRules.data.ok) {
                if (resultRules.data.payload != null) {
                    const {
                        availableToMarketplace,
                        availableToFomentation,
                        orderAntecipationMode,
                        confirmMerchandise,
                        cashbackOperation,
                        providerAllowedSendOrderToMarket,
                        orderStatusAllowedToMarketplace,
                        buyerSendXml,
                        daysAllowedSendOrderToMarket,
                        providerProvideBillets,
                        allowLots,
                        whoPaysCashback,
                        confirmStatus,
                        allowedPaymentType,
                        autoSendToMkt,
                        xmlRequiredForAnticipation,
                        availableToInvoiceDeadlineExtension,
                        interestRatePerMonth,
                        extendedDeadlineDays,
                        dataImportType,
                        canProviderSeeFees,
                        showReceivableTab,
                        modelOffers,
                        xApiKey,
                        xApiId,
                        XmlBindingType,
                        orderTypeRequiresXmlOrPdf,
                    } = resultRules.data.payload
                    this.activeStep = this.USER_TYPE_MIXIN.isBackOffice ? 1 : 0
                    this.groupRules = {
                        availableToMarketplace,
                        availableToFomentation,
                        orderAntecipationMode,
                        confirmMerchandise,
                        cashbackOperation: cashbackOperation * 100,
                        providerAllowedSendOrderToMarket,
                        orderStatusAllowedToMarketplace,
                        buyerSendXml,
                        daysAllowedSendOrderToMarket,
                        providerProvideBillets,
                        allowLots,
                        whoPaysCashback,
                        confirmStatus,
                        allowedPaymentType,
                        autoSendToMkt,
                        xmlRequiredForAnticipation,
                        availableToInvoiceDeadlineExtension,
                        interestRatePerMonth,
                        extendedDeadlineDays,
                        dataImportType,
                        canProviderSeeFees,
                        showReceivableTab,
                        modelOffers,
                        xApiKey,
                        xApiId,
                        XmlBindingType,
                        orderTypeRequiresXmlOrPdf: orderTypeRequiresXmlOrPdf || [],
                    }
                }
            }
            if (resultAssociatedSponsors.data.ok) {
                this.$store.commit('group/setSelectedSponsors', resultAssociatedSponsors.data.payload)
                if (resultAssociatedSponsors.data.payload) {
                    if (resultAssociatedSponsors.data.payload.length) {
                        this.sponsorIdsToDelete = resultAssociatedSponsors.data.payload.map(sponsor => sponsor.id)
                    }
                }
            }
        }

        if (this.USER_TYPE_MIXIN.isBackOffice) {
            this.groupRules.availableToFomentation = false
            this.groupRules.availableToMarketplace = true
            this.groupRules.whoPaysCashback = 'cashforce'
            this.groupRules.allowedPaymentType = 'all'
            this.activeStep = 1
        }
    },
    destroyed() {
        this.$store.commit('group/setSelectedSponsors', [])
    }

}
</script>

<style lang="scss" scoped>

</style>
